import axios from 'axios';
import constants from "../utils/constants";

export default axios.create({
  baseURL: constants.APPLICATION_INFO.ADSPIRE_COLLECTION_API
});